import { DIAGNOSIS_RULE_MAP } from "../constants";

export function RuleBadge({ ruleCode }) {
  const rule = DIAGNOSIS_RULE_MAP[ruleCode] || {
    label: ruleCode,
    className: "bg-gray-100 text-gray-700",
  };

  return (
    <span className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2 py-1 text-xs font-medium ${rule.className}`}>
      {rule.label}
    </span>
  );
}
